import type { FC } from 'react';
import React, { isValidElement, createContext, useContext } from 'react';

import type { IContextPropsOverriderProps, TContext } from './models';

const Context = createContext<TContext | undefined>(undefined);

export const ContextPropsProvider = Context.Provider;
export const ContextPropsOverrider: FC<React.PropsWithChildren<IContextPropsOverriderProps>> = ({
    children,
    contextMapping,
    forwardProps = false,
    ...rest
}) => {
    const context = useContext(Context);

    const transitProps = forwardProps ? rest : {};

    if (!context) {
        return isValidElement(children)
            ? React.cloneElement(children, {
                  ...transitProps,
              })
            : children;
    }

    const contextProps = Object.entries(contextMapping).reduce((acc, [propKey, contextKey]) => {
        const value = context[contextKey];
        if (value) {
            return {
                ...acc,
                [propKey]: value,
            };
        }

        return acc;
    }, {});

    // TODO: странное решение, если children невалидный, то почему-то возвращаем null, а не просто children без проброса пропсов. Беспричинный аффект на дерево виджетов.
    return isValidElement(children)
        ? React.cloneElement(children, {
              ...transitProps,
              ...contextProps,
          })
        : null;
};
